import { render, staticRenderFns } from "./TaskTypeSelect.vue?vue&type=template&id=1b139d0a&scoped=true&"
import script from "./TaskTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./TaskTypeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TaskTypeSelect.vue?vue&type=style&index=0&id=1b139d0a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b139d0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
